import api from '../../../api';

type FavoritesResponse = Record<
  string,
  {
    mediaLinks?: string[];
    userMaterial?: string[];
    whitepages?: string[];
  }
>;

export const deleteFavorite = async (
  favoriteType: 'user-material' | 'whitepages' | 'medialinks',
  moduleId: string,
  materialId: string,
) => {
  await api.delete(`studio/user/modules/${moduleId}/favorites/${favoriteType}/${materialId}`);
};

export const putFavorite = async (
  favoriteType: 'user-material' | 'whitepages' | 'medialinks',
  moduleId: string,
  materialId: string,
) => {
  await api.put(`studio/user/modules/${moduleId}/favorites/${favoriteType}/${materialId}`);
};

export const getFavoritesForModule = async (moduleId: string) => {
  const { data } = await api.get<FavoritesResponse>(
    `studio/user/modules/${moduleId}/favorites-v2?includeSubModules=true`,
  );

  Object.values(data).forEach(module => {
    delete Object.assign(module, { medialinks: module.mediaLinks })['mediaLinks'];
  });

  return data;
};
